//Password Strength
export const getStrongPasswordStatus = 'STRONG';
export const getMediumPasswordStatus = 'MEDIUM';
export const getWeakPasswordStatus = 'Password must have lowercase, uppercase, number and special char';

//REGEX
export const strongPasswordRegex =
  '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,})';
export const mediumPasswordRegex =
  '((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{6,}))';


//Notification config
export const getNotificationTimeOut = 3100;
//Status
export const getFailedText = 'Failed';
export const getErrorStatus = 'Error';
export const getSuccessStatus = 'Success';
export const getWarningStatus = 'Warning';
export const getInfoStatus = 'INFO';

// STATUS CODE
export const sucessState200 = 200;
export const notExpectedState409 = 409;
export const inCompleteState203 = 203;
export const serverErrorState500 = 500;